import classnames from 'classnames/bind'
import { useRef } from 'react'

// Libs

// Components
import Lottie from '@/components/common/Lottie'

// Constants

// Lotties
import loadingData from '@/assets/lotties/livemall-loading.json'
// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

export type LoadingProps = {
  isFull?: boolean
  position?: 'fixed' | 'absolute'
}

const Loading = ({ isFull = true, position = 'fixed' }: LoadingProps) => {
  const loadingRef = useRef<any>(null)

  return (
    <div className={cx('loading')} data-is-full={isFull} data-position={position}>
      <div className={cx('loading-lottie')} ref={loadingRef}>
        <Lottie lottieRef={loadingRef} animationData={loadingData} config={{ loop: true, autoplay: true }} />
      </div>
    </div>
  )
}

export default Loading
